export default {
  CONFIRMATION: 'early_settlement_confirmation',
  CHARGE_PAYMENTS: 'charge_early_settlement_payments',
}

export const EARLY_SETTLMENT_PAYMENTS_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
}
